import { resolveFeedRowMergeKey } from '@/domain/crypto/crypto-group-by-slug-feed.js';

/**
 * 静默刷新：按 merge key 就地替换已有行，保留已加载长度与顺序（不整表用第 1 页覆盖）。
 * 分钟盘同 series 会换成 api 中的 live 行；第 2 页及以后未出现在本页响应中的行原样保留。
 *
 * @param {object[]} previousRows
 * @param {object[]} apiRows
 * @returns {object[]}
 */
export function mergeSilentFeedRefreshRows(previousRows, apiRows) {
  const prev = Array.isArray(previousRows) ? previousRows : [];
  const next = Array.isArray(apiRows) ? apiRows : [];
  if (!prev.length) return next;
  if (!next.length) return prev;

  /** @type {Map<string, object>} */
  const byKey = new Map();
  for (const row of next) {
    const key = resolveFeedRowMergeKey(row);
    if (key) byKey.set(key, row);
  }
  if (!byKey.size) return prev;

  let any = false;
  const merged = prev.map((row) => {
    const key = resolveFeedRowMergeKey(row);
    if (!key || !byKey.has(key)) return row;
    const patched = byKey.get(key);
    if (patched !== row) any = true;
    return patched;
  });
  return any ? merged : prev;
}
